import React, {useRef, useCallback} from 'react';
import {useAnimationFrame} from 'Hooks/useAnimationFrame';

export const RenderFrameDiv: React.FC<
    {
        children?: React.ReactNode;
        onRenderFrame: () => React.CSSProperties;
    } & React.HTMLAttributes<HTMLDivElement>
> = (props) => {
    const {children, onRenderFrame, ...rest} = props;
    const divRef = useRef<null | HTMLDivElement>(null);

    const updateOnFrame = useCallback(() => {
        const css = onRenderFrame();
        Object.keys(css).forEach((key) => {
            if (divRef.current) {
                divRef.current.style[key] = css[key];
            }
        });
    }, [onRenderFrame, divRef]);

    useAnimationFrame(updateOnFrame);

    return (
        <div ref={divRef} {...rest}>
            {children}
        </div>
    );
};
